import { get } from 'lodash';
import React from 'react';
import { Image, StyleSheet, TouchableOpacity } from 'react-native';
import { defaultURL } from '../../../utils/common.constant';
import { getActions, getImageCardCover, getItemListClick } from '../../shared';

const INDICATORS_POSITION = {
  OUTSIDE: 1,
  INSIDE: 2,
};
const CarouselItem = (props: any) => {
  const { item, width, height, attrs, onPress } = props;
  const { attributes } = attrs;
  const {
    borderRadius = 8,
    cardCover,
    backgroundColor,
    slideIndicators,
  } = attributes;
  const imageResize = cardCover?.image?.imageResize;
  const imageHeight =
    slideIndicators?.enabled &&
    slideIndicators?.position === INDICATORS_POSITION.OUTSIDE
      ? height - 20
      : height;

  const imageType = get(cardCover, 'image.imageType');

  const placeholderImageUrl = get(
    attributes,
    'cardCover.image.binding.options.placeholderImage',
    null
  );

  const placeholderImageEnabled = get(
    attributes,
    'cardCover.image.binding.options.placeholderImageEnabled',
    false
  );

  const placeholderImage =
    placeholderImageEnabled && imageType !== 'uploaded'
      ? placeholderImageUrl
      : defaultURL;

  const imageUrl = getImageCardCover(item, cardCover) || placeholderImage;

  const handlePress = () =>
    onPress(getActions(attrs, 'onPress'), {
      itemListClick: getItemListClick(item),
    });

  return (
    <TouchableOpacity
      onPress={handlePress}
      style={[
        styles.container,
        { borderRadius, backgroundColor, width, height: imageHeight },
      ]}
    >
      <Image
        source={{ uri: imageUrl }}
        style={[styles.keyImage]}
        resizeMethod="resize"
        resizeMode={imageResize}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    overflow: 'hidden',
  },
  keyImage: {
    width: '100%',
    height: '100%',
  },
});

export default CarouselItem;
